var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showFab
    ? _c(
        "div",
        {
          staticClass: "sip-pwa-install",
          class: { "sip-pwa-install--solo": !_vm.aiWidgetEnabled },
        },
        [
          _c(
            "button",
            {
              staticClass: "sip-pwa-install__fab",
              attrs: {
                type: "button",
                "aria-label": _vm.installLabel,
                title: _vm.installLabel,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onInstallClick.apply(null, arguments)
                },
              },
            },
            [_c("admin-icon", { attrs: { name: "download", size: 22 } })],
            1
          ),
          _vm._v(" "),
          _c("transition", { attrs: { name: "sip-pwa-sheet" } }, [
            _vm.showIosSheet
              ? _c(
                  "div",
                  {
                    staticClass: "sip-pwa-sheet",
                    attrs: {
                      role: "dialog",
                      "aria-modal": "true",
                      "aria-labelledby": "sip-pwa-sheet-title",
                    },
                    on: {
                      click: function ($event) {
                        if ($event.target !== $event.currentTarget) return null
                        return _vm.closeIosSheet.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "sip-pwa-sheet__card" }, [
                      _c("div", { staticClass: "sip-pwa-sheet__head" }, [
                        _c("div", { staticClass: "sip-pwa-sheet__brand" }, [
                          _vm.logoUrl
                            ? _c("img", {
                                staticClass: "sip-pwa-sheet__logo",
                                attrs: { src: _vm.logoUrl, alt: _vm.appName },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "h2",
                              {
                                staticClass: "sip-pwa-sheet__title",
                                attrs: { id: "sip-pwa-sheet-title" },
                              },
                              [_vm._v("Install " + _vm._s(_vm.appName))]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "sip-pwa-sheet__sub" }, [
                              _vm._v("Add this app to your Home Screen"),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "sip-pwa-sheet__close",
                            attrs: { type: "button", "aria-label": "Close" },
                            on: { click: _vm.closeIosSheet },
                          },
                          [
                            _c("admin-icon", {
                              attrs: { name: "close", size: 16 },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("ol", { staticClass: "sip-pwa-sheet__steps" }, [
                        _c("li", [
                          _c("span", { staticClass: "sip-pwa-sheet__num" }, [
                            _vm._v("1"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "sip-pwa-sheet__copy" }, [
                            _vm._v(
                              "\n                            Tap\n                            "
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "sip-pwa-sheet__share",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      viewBox: "0 0 24 24",
                                      width: "16",
                                      height: "16",
                                      fill: "none",
                                      stroke: "currentColor",
                                      "stroke-width": "1.75",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  },
                                  [
                                    _c("path", { attrs: { d: "M12 16V4" } }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: { d: "M8 8l4-4 4 4" },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d: "M6 14v5a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-5",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Share")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", { staticClass: "sip-pwa-sheet__num" }, [
                            _vm._v("2"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "sip-pwa-sheet__copy" }, [
                            _vm._v("Tap "),
                            _c("strong", [_vm._v("Add to Home Screen")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("span", { staticClass: "sip-pwa-sheet__num" }, [
                            _vm._v("3"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "sip-pwa-sheet__copy" }, [
                            _vm._v("Tap "),
                            _c("strong", [_vm._v("Add")]),
                            _vm._v(" / "),
                            _c("strong", [_vm._v("Done")]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "sip-pwa-sheet__done",
                          attrs: { type: "button" },
                          on: { click: _vm.closeIosSheet },
                        },
                        [_vm._v("Got it")]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }